/*!
 * Manera Findstores
 * 
 */
$(document).ready(function(){
    /** scrollbar findstore list **/
    if($('#entries').length > 0) {
        //console.log('entries');
        window.overlayScrollbarsInstance = $('#entries').overlayScrollbars({
            className : "os-theme-dark",
            overflowBehavior: {
                x: 'hidden',
            },
            scrollbars: {
                autoHide: "leave",
                autoHideDelay: 200
            }
        }).overlayScrollbars();
    }

    $('input[name="location"]').on('focus',function(e){
        $(this).val('');
    });

    var nav = $('.nav_findstore').find('li');
    nav.on('click',function(e){
        nav.removeClass('active');
        $(this).addClass('active');

        if($(this).hasClass('display-map')){
            $('#map-wrapper').removeClass('d-none').addClass('d-block');
            $('#entries').removeClass('d-block').addClass('d-none');
        }
        else {
            $('#map-wrapper').removeClass('d-block').addClass('d-none');
            $('#entries').removeClass('d-none').addClass('d-block');
        }
    });
});